import React, { createContext, useContext } from 'react';

const ProductContext = createContext({
  activePackage: null,
  setActivePackage: () => {},
  activeBundle: null,
  setActiveBundle: () => {},
  businessData: null,
  setBusinessData: () => {},
});

export default ProductContext;
